module.exports = __webpack_public_path__ + "img/ats.cabb781e.svg";